<template>
  <div class="restore-container">
    <form
      v-if="step === 1"
      class="shadow-lg p-4 mb-5 bg-white rounded"
      v-on:submit.prevent="requestCode"
    >
      <h3 class="mb-4">Нууц үг сэргээх</h3>

      <b-input-group class="col-12 form-group mb-4">
        <b-input-group-prepend is-text>
          <b-icon icon="telephone-fill"></b-icon>
        </b-input-group-prepend>
        <b-form-input
          v-model.trim="phone"
          id="phone"
          name="phone"
          type="tel"
          inputmode="numeric"
          placeholder="Утасны дугаар"
        />
      </b-input-group>

      <button
        :disabled="!isValidPhone || isLoading"
        type="submit"
        class="col-6 btn btn-success float-right mt-2"
      >
        <b-spinner v-if="isLoading" small></b-spinner>
        <span v-else>илгээх</span>
      </button>
    </form>

    <form
      v-else
      class="shadow-lg p-4 mb-5 bg-white rounded"
      v-on:submit.prevent="verifyCode"
    >
      <h3 class="mb-2">Баталгаажуулах код</h3>
      <p class="text-muted mb-4">
        {{ phone }} дугаарт илгээсэн 4 оронтой кодыг оруулна уу.
      </p>

      <b-input-group class="col-12 form-group mb-3">
        <b-input-group-prepend is-text>
          <b-icon icon="shield-lock-fill"></b-icon>
        </b-input-group-prepend>
        <b-form-input
          v-model.trim="code"
          id="code"
          name="code"
          type="tel"
          inputmode="numeric"
          maxlength="4"
          placeholder="Баталгаажуулах код"
        />
      </b-input-group>

      <b-input-group class="col-12 form-group mb-3">
        <b-input-group-prepend is-text>
          <b-icon icon="lock-fill"></b-icon>
        </b-input-group-prepend>
        <b-form-input
          v-model="password"
          id="password"
          name="password"
          type="password"
          placeholder="Шинэ нууц үг"
        />
      </b-input-group>

      <b-input-group class="col-12 form-group mb-3">
        <b-input-group-prepend is-text>
          <b-icon icon="lock-fill"></b-icon>
        </b-input-group-prepend>
        <b-form-input
          v-model="passwordConfirm"
          id="passwordConfirm"
          name="passwordConfirm"
          type="password"
          placeholder="Шинэ нууц үг давтах"
        />
      </b-input-group>
      <p v-if="passwordConfirm && !passwordsMatch" class="form-error mb-3">
        Нууц үг таарахгүй байна.
      </p>

      <button
        :disabled="!canVerify || isLoading"
        type="submit"
        class="col-6 btn btn-success float-right mt-2"
      >
        <b-spinner v-if="isLoading" small></b-spinner>
        <span v-else>батлах</span>
      </button>

      <button
        type="button"
        class="col-6 btn btn-outline-secondary mt-2"
        :disabled="isLoading"
        @click="backToPhone"
      >
        буцах
      </button>
    </form>
  </div>
</template>

<script>
import ownerService from "../api-services/owner.service";
import Swal from "sweetalert2";

const Toast = Swal.mixin({
  animation: true,
  timer: 3000,
  showConfirmButton: false,
});
export default {
  data() {
    return {
      step: 1,
      isLoading: false,
      phone: "",
      code: "",
      password: "",
      passwordConfirm: "",
    };
  },

  computed: {
    isValidPhone() {
      return /^[0-9]{8}$/.test(this.phone);
    },
    passwordsMatch() {
      return this.password === this.passwordConfirm;
    },
    canVerify() {
      return (
        /^[0-9]{4}$/.test(this.code) &&
        this.password.length > 0 &&
        this.passwordsMatch
      );
    },
  },

  methods: {
    async requestCode() {
      this.isLoading = true;
      try {
        const { data } = await ownerService.resetByPhone({
          phone: this.phone,
        });
        if (data.status == "success") {
          Toast.fire({
            icon: "success",
            title: data.message,
          });
          this.step = 2;
        } else {
          Toast.fire({
            icon: "error",
            title: data.message,
          });
        }
      } catch (ex) {
        Toast.fire({
          icon: "error",
          title: "Сүлжээний алдаа",
        });
      } finally {
        this.isLoading = false;
      }
    },

    async verifyCode() {
      if (!this.passwordsMatch) {
        Toast.fire({
          icon: "error",
          title: "Нууц үг таарахгүй байна.",
        });
        return;
      }

      this.isLoading = true;
      try {
        const { data } = await ownerService.resetByPhoneVerify({
          phone: this.phone,
          code: this.code,
          password: this.password,
        });
        if (data.status == "success") {
          Toast.fire({
            icon: "success",
            title: data.message,
          }).then(() => {
            this.$router.push({ path: "/" });
          });
        } else {
          Toast.fire({
            icon: "error",
            title: data.message,
          });
        }
      } catch (ex) {
        Toast.fire({
          icon: "error",
          title: "Сүлжээний алдаа",
        });
      } finally {
        this.isLoading = false;
      }
    },

    backToPhone() {
      this.step = 1;
      this.code = "";
      this.password = "";
      this.passwordConfirm = "";
    },
  },

  components: {},
};
</script>
<style scoped>
.restore-container {
  padding: 80px 50px 50px 50px;
  font-family: "Roboto", sans-serif;
}
.shadow-lg {
  max-width: 500px;
  margin: 0 auto 0 auto;
  min-height: 180px;
}
.form-error {
  color: #e20b0bad;
  margin: 0 0 0 47px;
  text-align: start;
}
</style>
